import { action, makeObservable, observable } from 'mobx';
import { Store } from '../store/store';
import { StoreNode } from '../store';
import { AuthFlowResponse, AuthFlowResponseType } from '../services/auth/authFlowSchema';
import { RouteContext } from './routeContext';
import { RouteType } from './routeSchema';
import { RouteState } from './routeStateMixin';

import { INIT_DEBUGGER, TRACE } from '../core/debug/debugMacros';

export class AuthRouteState
  extends RouteState(StoreNode) {

  constructor(store: Store) {
    super(store);
    makeObservable(this, {
      flowResponse: observable,
      attached: action,
      detached: action,
      reset: action,
      setFlowResponse: action,
    });

    INIT_DEBUGGER(this, { color: 'teal' });
    TRACE(this, `constructor()`);
  }

  readonly nodeType = 'AuthRoute';
  readonly routeType = RouteType.Auth;

  flowResponse: AuthFlowResponse | null = null;

  async attached(routeContext: RouteContext) {
    TRACE(this, `attached()`, { routeContext }, this.__traceState);

    this.reset();
    this.baseAttached(routeContext);

    this.setLoading();

    const { authService, routingService } = this.store;
    routingService.routeAttached(routeContext);

    const [res, err] = await authService.runAuthRouteFlow({
      routeContext
    });

    if (err) {
      if (err.code === 'Forbidden')
        return this.setError(err);

      return this.setFlowResponse({
        responseType: AuthFlowResponseType.RedirectToLoginPage,
        error: err
      });
    }

    return this.setFlowResponse(res!);
  }

  detached() {
    TRACE(this, `detached()`, this.__traceState);

    this.baseDetached();
    this.reset();

    const { routingService } = this.store;
    routingService.routeDetached();
  }

  reset() {
    this.baseReset();
    this.flowResponse = null;
  }

  setFlowResponse(res: AuthFlowResponse) {
    this.setLoaded();
    this.flowResponse = res;
  }
  
  private get __traceState() {
    return {
      ...this.__baseTraceState,
      flowResponse: this.flowResponse
    }
  }
}